module.exports = __webpack_public_path__ + "media/images/bus_operator_admin/bus-banner-40aa502862c04eeecf94cc9fe3deee34.svg";